import React from 'react';
import classNames from 'classnames';
import './block-wrapper.less';

export default function BlockWrapper(props) {
  const { title, hidden = false, className, right } = props;

  if (hidden) return null;

  return (
    <div className={classNames('info-block-wrapper', className)}>
      <div className="block-wrapper__header__wrapper">
        <div className="info-block-wrapper-title">{title}</div>
        <div className="info-block-wrapper-right">{right}</div>
      </div>
      {props.children}
    </div>
  );
}
